import React from 'react';
import { ColorPicker, Slider, Space } from 'antd';
import type { Color } from 'antd/es/color-picker';

interface ColorOpacityValue {
  color: string;
  opacity: number;
}

interface ColorOpacityInputProps {
  value?: ColorOpacityValue;
  onChange?: (value: ColorOpacityValue) => void;
}

const ColorOpacityInput: React.FC<ColorOpacityInputProps> = ({
  value = { color: '#9c27b0', opacity: 80 },
  onChange,
}) => {
  const handleColorChange = (newColor: Color | string) => {
    const colorString = typeof newColor === 'string' ? newColor : newColor.toHexString();
    onChange?.({ ...value, color: colorString });
  };

  const handleOpacityChange = (newOpacity: number) => {
    onChange?.({ ...value, opacity: newOpacity });
  };

  return (
    <Space direction="vertical" style={{ width: '100%' }}>
      <ColorPicker value={value.color} onChange={handleColorChange} showText />
      <Slider min={0} max={100} step={5} value={value.opacity} onChange={handleOpacityChange} />
    </Space>
  );
};

export default ColorOpacityInput;